<template>
  <div class="d-flex position-relative tooltip-parent">
    <slot name="element"></slot>
    <div
      class="tooltip-icon exp-bg"
      :class="{ 'edit-color-tooltip': editColorTooltip }"
      :style="tooltipPosition"
    >
      <h6 :class="{ 'mb-0': !hasDescription }"><slot name="title"></slot></h6>
      <p class="mb-0">
        <slot></slot>
      </p>
      <span class="triangle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    editColorTooltip: {
      type: Boolean,
      default: false
    },
    left: {
      type: Number,
      required: false,
      default: 8
    },
    bottom: {
      type: Number,
      required: false,
      default: 200
    }
  },
  computed: {
    hasTitle() {
      return this.$slots.title ? true : false;
    },
    hasDescription() {
      return this.$slots.default ? true : false;
    },
    tooltipPosition() {
      return !this.editColorTooltip ? ` left: ${this.left}px; bottom:${this.bottom}% ` : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip-parent:hover .tooltip-icon {
  display: flex;
}
.tooltip-icon {
  position: absolute;
  width: 200px;
  bottom: 200%;
  left: 8px;
  display: none;
  flex-direction: column;
  justify-content: center;
  color: white;
  border-radius: 4px 4px 4px 0;
  z-index: 100;
  padding: 16px;
  &.edit-color-tooltip {
    left: 60px;
    bottom: 0px;
    border-radius: 4px;
    padding: 10px;
    width: max-content;
    .triangle {
      border-color: transparent var(--exp-color) transparent transparent;
      bottom: 11px;
      left: -28px;
      border-width: 7px 15px;
    }
    @include lg {
      bottom: 0;
      top: 60px;
      left: -32px;
      padding: 16px;
      .triangle {
        top: -26px;
        left: 34px;
        bottom: 0;
        border-width: 15px;
        border-color: transparent transparent var(--exp-color) transparent;
      }
    }
  }
  & p {
    font-size: 12px;
    margin: 0;
  }
  & h6 {
    font-size: 14px;
    width: 100%;
    text-align: left;
  }
  & .triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 15px 0 0;
    position: absolute;
    bottom: -15px;
    left: 0;
    border-color: var(--exp-color) transparent transparent transparent;
    border-width: 15px 15px 0 0;
  }
}
</style>
